<template>
  <div>
    <Dialog
      :visible.sync="commentDialog1"
      :style="{ width: '600px', height: '260px', overflowY: 'auto' }"
      header="Comment box"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="a">{{ label }}</label>
          <InputText id="a" v-model.trim="comment" />
          <small class="p-invalid" v-if="submitted && !comment"
            >Comment is required.</small
          >
        </div>
      </div>

      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-3 p-md-3 p-sm-3"></div>
          <div class="p-lg-3 p-md-3 p-sm-3"></div>
          <div class="p-lg-3 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              style="width: 100px;"
              @click="$emit('close')"
            />
          </div>
          <div class="p-lg-3 p-md-3 p-sm-3">
            <ProgressSpinner
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;"
              strokeWidth="5"
              fill="#EEEEEE"
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              style="width: 100px;"
              @click="save"
            />
          </div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
export default {
  props: {
    commentDialog: {
      type: Boolean,
      required: true
    },
    label: {
      type: String,
      required: false
    },
    reload: {
      type: Number,
      required: false
    },
    sendingRequest: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    reload(val) {
      this.comment = "";
      this.submitted = false;
    }
  },
  data: () => ({
    comment: "",
    submitted: false
  }),
  computed: {
    commentDialog1: {
      set(val) {
        if (!val) {
          this.$emit("close");
        }
      },
      get() {
        return this.commentDialog;
      }
    }
  },
  methods: {
    save() {
      this.submitted = true;
      if (this.comment) this.$emit("save", this.comment);
    }
  }
};
</script>

<style></style>
